module.exports = __webpack_public_path__ + "static/media/feature_human_security.db989ccc.png";